import * as React     from "react";
import { AppFactory } from "@geenee/common";
import { appModule }  from "./magellan/di/di";
import { Builder }    from "./main";

const app = AppFactory.bootstrap(appModule, { elementId: "root" });
app.render(Builder);
